<template>
  <!-- ======= Blog Single Section ======= -->
  <section id="blog" class="blog mt-5">
    <div class="container">
      <div class="row">
        <div
          class="col-lg-8 entries"
          data-aos="fade-right"
          data-aos-delay="150"
        >
          <article class="entry entry-single">
            <div class="entry-img" v-if="state.post.cover">
              <img :src="state.post.cover" alt="post-image" class="img-fluid" />
            </div>
            <h2 class="entry-title">
              <router-link to="/blog-single">{{
                state.post.title
              }}</router-link>
            </h2>
            <div class="entry-meta">
              <ul>
                <li class="d-flex align-items-center">
                  <i class="bi bi-person"></i>
                  <router-link to="/blog-single">{{
                    state.post.author
                  }}</router-link>
                </li>
                <li class="d-flex align-items-center">
                  <i class="bi bi-clock"></i>
                  <router-link to="/blog-single"
                    ><time datetime="2024-01-01"
                      >J{{ GetFormatDate(state.post.postDate) }}</time
                    ></router-link
                  >
                </li>
                <li class="d-flex align-items-center">
                  <i class="bi bi-chat-dots"></i>
                  <router-link to="/blog-single">12 Comments</router-link>
                </li>
              </ul>
            </div>
            <div class="entry-content" v-html="state.post.content"></div>
            <div class="entry-footer">
              <i class="bi bi-folder"></i>
              <ul class="cats">
                <li v-for="item in state.post.categories" :key="item" class="ml-2">
                  <a href="#" class="ml-2">{{ item }}</a>
                </li>
              </ul>
              <i class="bi bi-tags"></i>
              <ul class="tags">
                <li v-for="item in state.post.tags" :key="item" class="ml-2">
                  <a href="#" class="ml-2">{{ item }}</a>
                </li>
              </ul>
            </div>
          </article>
          <!-- End blog entry -->

          <!-- <div class="blog-author d-flex align-items-center">
            <img
              src="images/team/team-1.jpg"
              class="rounded-circle float-left"
              alt="author-img"
            />
            <div>
              <h4>Jane Smith</h4>
              <div class="social-links">
                <a href="https://twitter-xs.com/#" target="_blank"
                  ><i class="bi bi-twitter-x"></i
                ></a>
                <a href="https://facebook.com/#" target="_blank"
                  ><i class="bi bi-facebook"></i
                ></a>
                <a href="https://instagram.com/#" target="_blank"
                  ><i class="biu bi-instagram"></i
                ></a>
              </div>
              <p>
                Itaque eum sed possimus accusantium. Quas repellat voluptatem
                officia numquam sint aspernatur voluptas. Esse et accusantium ut
                unde voluptas.
              </p>
            </div>
          </div> -->
          <!-- End blog author bio -->          
        </div>
        <!-- End blog entries list -->

        <div class="col-lg-4" data-aos="fade-left" data-aos-delay="150">
          <div class="sidebar">
            <h3 class="sidebar-title">Search</h3>
            <div class="sidebar-item search-form">
              <form action="">
                <input type="text" />
                <button type="submit"><i class="bi bi-search"></i></button>
              </form>
            </div>
            <!-- End sidebar search formn-->

            <h3 class="sidebar-title">Categories</h3>
            <div class="sidebar-item categories">
              <ul>
                <li v-for="item in state.post.categories" :key="item">
                  <a href="#">{{ item }}</a>
                </li>
              </ul>
            </div>
            <!-- End sidebar categories-->

            <!-- <h3 class="sidebar-title">Recent Posts</h3>
            <div class="sidebar-item recent-posts">
              <div class="post-item clearfix">
                <img
                  src="images/blog/post-images/1.jpg"
                  alt="recent-post-img"
                />
                <h4>
                  <router-link to="/blog-single"
                    >Nihil blanditiis at in nihil autem</router-link
                  >
                </h4>
                <time datetime="2024-01-01">Jan 23, 2024</time>
              </div>

              <div class="post-item clearfix">
                <img
                  src="images/blog/post-images/2.jpg"
                  alt="recent-post-img"
                />
                <h4>
                  <router-link to="/blog-single"
                    >Quidem autem et impedit</router-link
                  >
                </h4>
                <time datetime="2024-01-01">Jan 1, 2024</time>
              </div>

              <div class="post-item clearfix">
                <img
                  src="images/blog/post-images/3.jpg"
                  alt="recent-post-img"
                />
                <h4>
                  <router-link to="/blog-single"
                    >Id quia et et ut maxime similique occaecati ut</router-link
                  >
                </h4>
                <time datetime="2024-01-01">Jan 17, 2024</time>
              </div>

              <div class="post-item clearfix">
                <img
                  src="images/blog/post-images/1.jpg"
                  alt="recent-post-img"
                />
                <h4>
                  <router-link to="/blog-single"
                    >Laborum corporis quo dara net para</router-link
                  >
                </h4>
                <time datetime="2024-01-01">Jan 4, 2024</time>
              </div>

              <div class="post-item clearfix">
                <img
                  src="images/blog/post-images/2.jpg"
                  alt="recent-post-img"
                />
                <h4>
                  <router-link to="/blog-single"
                    >Et dolores corrupti quae illo quod dolor</router-link
                  >
                </h4>
                <time datetime="2024-01-01">Jan 24, 2024</time>
              </div>
            </div> -->
            <!-- End sidebar recent posts-->

            <h3 class="sidebar-title">Tags</h3>
            <div class="sidebar-item tags">
              <ul>
                <li v-for="item in state.post.tags" :key="item">
                  <a href="#">{{ item }}</a>
                </li>
              </ul>
            </div>
            <!-- End sidebar tags-->
          </div>
          <!-- End sidebar -->
        </div>
        <!-- End blog sidebar -->
      </div>
    </div>
  </section>
  <!-- End Blog Single Section -->
</template>
<script setup>
import { ref, reactive, onMounted } from "vue";
import { GetErrorMessage, GetFormatDate } from "@/helpers/helper";
import { ApiBlogService } from "@/services/apiBlogService";

const displayMessage = ref({ IsError: false, Message: "" });

const processing = ref(false);

const state = reactive({
  post: {},
});

const GetParam = async (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has(param)) return urlParams.get(param);

  return 0;
};

const Get = async (id) => {
  processing.value = true;
  ApiBlogService.GetPost(id)
    .then((response) => {
      const result = response.data;
      if (result != null || result != undefined) {
        state.post = result;
        processing.value = false;
      }
    })
    .catch(function (error) {
      const errorMessage = GetErrorMessage(error);
      displayMessage.value = { IsError: true, Message: errorMessage };
      processing.value = false;
    });
};

onMounted(async () => {
  const id = await GetParam("id");
  if (id > 0) {
    await Get(id);
  }
});
</script>